import {
  HIDDEN_WELL_KNOWN_FIELD_KEYS,
  WELL_KNOWN_FIELD_ORDER,
} from '~/common/constants/wellKnownFields';

const sortByFieldOrder = (keyA: string, keyB: string): number => {
  const indexA = WELL_KNOWN_FIELD_ORDER.indexOf(
    keyA as (typeof WELL_KNOWN_FIELD_ORDER)[number],
  );
  const indexB = WELL_KNOWN_FIELD_ORDER.indexOf(
    keyB as (typeof WELL_KNOWN_FIELD_ORDER)[number],
  );

  if (indexA !== -1 && indexB !== -1) {
    return indexA - indexB;
  }

  if (indexA !== -1) return -1;

  if (indexB !== -1) return 1;

  return 0;
};

export const sortAndFilterWellKnownFields = <T>(
  fields: Record<string, T>,
): T[] => {
  const fieldsArray = Object.entries(fields).filter(
    ([key]) => !HIDDEN_WELL_KNOWN_FIELD_KEYS.includes(key as any),
  );

  fieldsArray.sort(([keyA], [keyB]) => sortByFieldOrder(keyA, keyB));

  return fieldsArray.map(([_, field]) => field);
};

export const sortAndFilterWellKnownFieldIds = (
  normalizedFields: Record<string, any>,
): string[] => {
  const entries = Object.entries(normalizedFields).filter(
    ([key]) => !HIDDEN_WELL_KNOWN_FIELD_KEYS.includes(key as any),
  );

  entries.sort(([keyA], [keyB]) => sortByFieldOrder(keyA, keyB));

  return entries.map(([key]) => key);
};
